import {TypedUseSelectorHook, useSelector} from "react-redux";
import {RootState} from "../stores/authorizationStore";

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
